let forms = {
   change_profile: {
      icon: 'fa fa-user',
      title: 'User Profile',
      subtitle: 'View and Update Profile Details',
      forms: [
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'firstName',
            validation: 'required|min:3|max:50', label: 'First Name',
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'lastName',
            validation: 'required|min:3|max:50', label: 'Last Name',
         },
         {
            type: 'text', form_type: 'email', class: 'col-12 col-md-6', model: 'email',
            validation: 'required|min:3|max:150', label: 'Email',disabled: true
         },
         {
            type: 'text', form_type: 'text', class: 'col-12 col-md-6', model: 'phoneNumber',
            validation: 'required|min:3|max:20', label: 'Phone Number',disabled: true
         },
      ]
   },
   change_password: {
      icon: 'fa fa-user',
      title: 'Change Password',
      subtitle: 'Change User password',
      forms: [
         {
            type: 'text', form_type: 'password', class: 'custom-input col-12', model: 'currentPassword',
            validation: 'required|min:3|max:150', label: 'Current Password'
         },
         {
            type: 'text', form_type: 'password', class: 'custom-input col-12', model: 'password',
            validation: 'required|min:3|max:150', label: 'Password'
         },
         {
            type: 'text', form_type: 'password', class: 'custom-input col-12', model: 'confirmPassword',
            validation: 'required|min:3|max:150', label: 'Confirm Password'
         },
      ],
   },
   change_project: {
      icon: 'fa fa-user',
      title: 'Change Password',
      subtitle: 'Change User password',
      forms: [
         {
            type: 'select', class: 'col-12', model: 'project', filterable: true, clearable: true,
            multiple: false, options: [], validation: 'required', label: 'Project'
         },
      ],
   },
}

export default {
   forms: utils.generateAllFormData(forms),
}